<div class="wrapper">
    <div class="content">
        <ng-container *ngIf="isActiveTask; else showScheduledTaskConfirmation">
            <ng-container *ngIf="newContacts.length; else showRemoveOnlyMessage">
                <div class="blue header">
                    Invites are ready to send to your new invitees!
                    <span class="header__subtitle">
                        Your meeting assistant ({{ currentUser?.avatar }}) can send the invites for you
                    </span>
                    <strong>or</strong> you can generate a private invite link to send on your own.
                </div>
                <p class="content__body">
                    Either way, your <strong>new</strong> invitees will be able to select a
                    <span class="strong">{{ wizardService.options.meetingLength | durationTime }} meeting</span> time
                    based on {{ availabilityTypeText }} availability
                    <span class="strong"
                        >between {{ wizardService.options.dateStart | date: 'MMMM d' }} and
                        {{ wizardService.options.dateEnd | date: 'MMMM d' }}</span
                    >. Calendar confirmations will be sent once the meeting is booked.
                </p>
                <p *ngIf="hasRemovedContacts">
                    Removed attendees will be notified that their attendance is no longer required.
                </p>
            </ng-container>
            <ng-template #showRemoveOnlyMessage>
                <div class="blue header">Meeting notifications are ready to send!</div>
                <p class="content body">
                    Removed attendees will be notified that their attendance is no longer required, and calendars will
                    be automatically updated.
                </p>
            </ng-template>
        </ng-container>
        <ng-template #showScheduledTaskConfirmation>
            <ng-container *ngIf="newContacts.length; else showRemoveOnlyMessage">
                <div class="blue header">Meeting notifications are ready to send to your new invitees!</div>

                <p class="content body">
                    New invitees will be notified that they are invited to a meeting scheduled at:
                    <span class="strong">{{ meetingTime?.start | date: 'MMMM d' }}</span> at
                    <span class="strong">{{ meetingTime?.start | date: 'h:mm a' }}</span>
                </p>

                <p *ngIf="hasRemovedContacts">
                    Removed attendees will be notified that their attendance is no longer required, and calendars will
                    be automatically updated.
                </p>
            </ng-container>
            <ng-template #showRemoveOnlyMessage>
                <div class="blue header">Meeting notifications are ready to send!</div>
                <p class="content body">
                    Removed attendees will be notified that their attendance is no longer required, and calendars will
                    be automatically updated.
                </p>
            </ng-template>
        </ng-template>

        <div *ngIf="newContacts.length" class="ui list">
            <div class="ui tiny header">New Invitees:</div>
            <ng-container *ngFor="let contact of newContacts">
                <div class="item">
                    {{ contact.name }}
                    <span class="light">({{ contact.defaultEmail || (contact.email && contact.email[0]) }})</span>
                    <div *ngIf="contact | checkIsVIP: vipContacts" class="vip">
                        <i class="ui star icon"></i>
                        <span class="vip__tooltip">VIP</span>
                    </div>
                </div>
            </ng-container>
        </div>

        <div *ngIf="existingContacts.length" class="ui list">
            <div class="ui tiny header">Existing Invitees:</div>
            <ng-container *ngFor="let contact of existingContacts">
                <div class="item">
                    {{ contact.name }}
                    <span class="light">({{ contact.defaultEmail || (contact.email && contact.email[0]) }})</span>
                    <div *ngIf="contact | checkIsVIP: vipContacts" class="vip">
                        <i class="ui star icon"></i>
                        <span class="vip__tooltip">VIP</span>
                    </div>
                </div>
            </ng-container>
        </div>

        <div *ngIf="availabilityUsers?.length" class="ui list">
            <div class="ui tiny header">
                This is a {{ availabilityTypeText }} meeting, based on the availability of:
            </div>
            <ng-container *ngFor="let member of availabilityUsers">
                <div class="item">
                    {{ member.name }}
                    <span class="light">({{ member.defaultEmail || (member.email && member.email[0]) }})</span>
                </div>
            </ng-container>
        </div>
    </div>
    <img class="ui medium image" src="/assets/images/time-selection.svg" />
</div>
